import {
  GET_PATIENT_CERTIFICATION_DOC, SET_CERTIFICATION_ID, RESET_CERTIFICATION_ID,
  SET_UNCLOSED_CERTIFICATION_ID, RESET_UNCLOSED_CERTIFICATION_ID, REDIRECT_TO_UNCLOSED_CERT,
  RESET_REDIRECT_TO_UNCLOSED_CERT
} from 'redux/types/physician';
import { PayloadAction, RESET_STATE } from '../types/global';

export interface CertificationState {
  dashboardDocuments: any,
  certificationIdEncrypted: string,
  unclosedCertificationIdEncrypted: string,
  redirectToUnclosedCert: boolean
}

const INITIAL_CERTIFICATION_STATE: CertificationState = {
  dashboardDocuments: [],
  certificationIdEncrypted: null,
  unclosedCertificationIdEncrypted: null,
  redirectToUnclosedCert: null
};

// eslint-disable-next-line max-len
const certificationReducer = (state: CertificationState = INITIAL_CERTIFICATION_STATE, action: PayloadAction<any>): CertificationState => {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_CERTIFICATION_STATE;
    case GET_PATIENT_CERTIFICATION_DOC:
      return { ...state, dashboardDocuments: action.payload };
    case SET_CERTIFICATION_ID:
      return { ...state, certificationIdEncrypted: action.payload };
    case RESET_CERTIFICATION_ID:
      return { ...state, certificationIdEncrypted: null };
    case SET_UNCLOSED_CERTIFICATION_ID:
      return { ...state, unclosedCertificationIdEncrypted: action.payload };
    case RESET_UNCLOSED_CERTIFICATION_ID:
      return { ...state, unclosedCertificationIdEncrypted: null };
    case REDIRECT_TO_UNCLOSED_CERT:
      return { ...state, redirectToUnclosedCert: action.payload };
    case RESET_REDIRECT_TO_UNCLOSED_CERT:
      return { ...state, redirectToUnclosedCert: null };
    default:
      return state;
  }
};

export default certificationReducer;
